import BaseDrawerFeature from '@framework/workbench/common/feature/base-drawer-feature';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { IMultiplyModel } from '@src/slide/domain/ui-model/element-modeles/Interface/multiply-model.interface';
import { IGroupModel } from '@src/slide/domain/ui-model/element-modeles/Interface/group-model.interface';
import { ITableModel } from '@src/slide/domain/ui-model/element-modeles/Interface/table-model.interface';
import { getMenuValues } from '@src/slide/application/service/menu-manager/menu-values';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { objectCompareLite } from '@src/slide/infrastructure/module/independent/object-operation';
import { getAllChildModels } from '@src/slide/domain/ui-model/element-modeles/property/utils/merge-property';

export default class BaseDrawerEffectFeature extends BaseDrawerFeature {
    public isOnlyChangeUI: boolean | undefined;

    // 是否是部分设置了文字效果，是页面上则需要显示...
    protected isTextMultiDiffValue = (detailEffectKey: string): boolean => {
        const model = this.getSelectModel();
        if (!model) {
            return false;
        }
        let children;
        if (model.type === UIModelType.MULTIPLY) {
            children = (model as IMultiplyModel).selectedModels;
        } else if (model.type === UIModelType.GROUP) {
            children = getAllChildModels(model as IGroupModel, true);
        } else if (model.type === UIModelType.TABLE) {
            children = (model as ITableModel).selectedCellRanges
                .map(range => (model as ITableModel).tableItems[range.rowStart][range.colStart]);
        } else {
            children = [model];
        }
        const fontEffectValueArr = children
            .map(model => getMenuValues(model)[ActionType.FONT_EFFECT]?.[detailEffectKey]);
        // （1）全部都没有设置过效果
        const noEffectArr = fontEffectValueArr.filter(e => e === undefined);
        if (noEffectArr.length === children.length) {
            return false;
        }
        // 单个shape如果不同textRuns设置了不同的效果，则获取MenuValues返回的是multi，而若设置的是相同的效果（即使是多种），也会返回font-effect: { shadow: {}... }
        const notMultiValueArr = fontEffectValueArr.filter(value => value !== 'multi');
        // （2）只要有一个shape存在multi，则说明是部分存在文字效果的场景，无需继续判断
        if (notMultiValueArr.length < children.length) {
            return true;
        }
        // （3）说明每个shape都有自己一致的效果，下来要看各shape的效果是否也一致
        for (let i = 1; i < fontEffectValueArr.length; i++) {
            const isEqual = objectCompareLite(fontEffectValueArr[0], fontEffectValueArr[i]);
            if (!isEqual) {
                // 有一个不同，就不需要继续判断了
                return true;
            }
        }
        return false;
    };

    protected getFontEffect = (type: string) => this.getPropertyMenu()?.values?.[ActionType.FONT_EFFECT]?.[type];
}
